import { resolveComponent as _resolveComponent, mergeProps as _mergeProps, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _directive_mask = _resolveDirective("mask")!

  return _withDirectives((_openBlock(), _createBlock(_component_v_text_field, _mergeProps(_ctx.$attrs, {
    type: "tel",
    "model-value": _ctx.binded.masked || (_ctx.$attrs.phone as string)?.slice(1),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:phone', _ctx.binded.unmasked ? '7' + _ctx.binded.unmasked : '')))
  }), null, 16, ["model-value"])), [
    [_directive_mask, _ctx.binded, _ctx.opts]
  ])
}